module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/define-property.js
// module id = 44
// module chunks = 35783957827783 114276838955818 162898551421021